// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__s8ll2","disabled":"FileBtn_disabled__2jZW1","warn":"FileBtn_warn__IAD-S","fade":"FileBtn_fade__Se0Mw"};